<template>
  <div class="settings workorder-settings">
    <h4>Настройка нарядов</h4>

    <div class="menu-settings">
      <ImportFromExcel style="margin-bottom: 10px"/>

      <div class="edit-li">
        Учет трудоемкости
        <el-checkbox  @change="save" v-model="form.labor"></el-checkbox>
      </div>
      <div class="edit-li">
        Учет стоимости
        <el-checkbox  @change="save" v-model="form.price"></el-checkbox>
      </div>
      <div class="edit-li">
        Учет числености
        <el-checkbox  @change="save" v-model="form.prof"></el-checkbox>
      </div>
      <div class="edit-li">
        Учет техники
        <el-checkbox  @change="save" v-model="form.tech"></el-checkbox>
      </div>
    </div>

    <h4>Аналитика наряда</h4>

    <el-radio-group class="menu-settings radio" @change="save" v-model="form.analytics">
      <div
        class="edit-li"
      >
        <el-radio label="without">Без аналитики</el-radio>
      </div>
      <div
        class="edit-li"
      >
        <el-radio label="volume">Физобъемы</el-radio>
      </div>
      <div
        class="edit-li"
      >
        <el-radio label="price"> Стоимость
        </el-radio>
      </div>
      <div
        class="edit-li"
      >
        <el-radio label="progress">Трудоемкость</el-radio>
      </div>
    </el-radio-group>

    <div class="menu-settings">

      <div class="edit-li with-border" v-if="this.$store.state.project.tasks">
        <router-link to="/dashboard/workorders/categories" class="link-cont">
            <span>
              Категории нарядов
            </span>
          <i class="fas fa-chevron-right"></i>
        </router-link>
      </div>
    </div>


  </div>
</template>

<script>
import firebase from "firebase";
import dayjs from "dayjs";
import ImportFromExcel from "./ImportFromExcel";

export default {
  name: "Settings",
  components: {ImportFromExcel},
  data() {
    return {
      form: {
        analytics: 'without'
      }
    }
  },
  mounted() {
    const {
      workorder
    } = this.$store.state.project;

    this.form = {
      ...this.form,
      ...workorder
    };
  },
  methods: {
    save() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .update({
          workorder: {...this.form},
        }).then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        this.$store.dispatch('setProject', {
          workorder: {...this.form},
        });
      })
        .catch((error) => console.error(error));
    }
  }
}
</script>

<style scoped lang="scss">
.settings {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.menu-settings {
  margin-top: 32px;

  .edit-li {
    display: flex;
    justify-content: space-between;
    height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    align-items: center;
    padding: 0 10px;
    text-decoration: none;
    color: #000;

    span:first-child {
      margin-right: 20px;
    }

    span {
      margin-right: 5px;
    }

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f5f5f5;
    }
  }

}

.link-cont {
  display: flex;
  justify-content: space-between;
  color: #000;
  text-decoration: none;
  flex: 1;
}

.with-border {
  border-top: 1px solid rgba(0, 0, 0, 0.18);
  margin-top: 10px;
}

</style>
<style lang="scss">
.workorder-settings {
  .edit-li {
    display: flex;
    width: 100%;
    flex: 1;

    .el-radio {
      width: 100%;
      display: flex;
      flex: 1;
      height: 40px;
      align-items: center;
      justify-content: space-between;
      flex-direction: row-reverse;
    }
  }

  .menu-settings.radio {
    display: flex;
    flex: 1;
    width: 100%;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/Settings.vue